import React, {useEffect, useState} from 'react';
import Modal from 'react-bootstrap/Modal';
import {Form} from 'react-bootstrap';
import ButtonCancel from '../../modules/form/ButtonCancel';
import ButtonSubmit from '../../modules/form/ButtonSubmit';
import {useIntl} from 'react-intl';
import {useClientId} from '../../hooks/useClientId';
import {handleEmailChange} from '../../api/email';
import {User} from '../../../Domains/Auth/Types/User';
import {useUpdateUser} from '../../../Domains/Auth/Hooks/UserManager';

interface ModalEditUserProps {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  user: User;
  setSelectedUser: (contact: User | undefined) => void;
}

const ModalEditUser = ({showModal, setShowModal, user}: ModalEditUserProps): JSX.Element => {
  const intl = useIntl();
  const [name, setName] = useState(user.name);
  const [first_name, setFirstName] = useState(user.first_name);
  const [mail, setMail] = useState(user.mail);
  const [emailError, setEmailError] = useState('');
  const clientId = useClientId();

  const {mutate} = useUpdateUser();

  useEffect(() => {
    setName(user.name);
    setMail(user.mail);
    setFirstName(user.first_name);
  }, [user]);

  const handleUpdate = async (event: React.FormEvent) => {
    event.preventDefault();
    if (emailError) {
      return;
    }

    mutate({
      id: user.id,
      name: name,
      first_name: first_name,
      mail: mail,
    });

    setShowModal(false);
  };

  return (
    <Modal show={showModal} onHide={() => setShowModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>
          {intl.formatMessage({
            id: 'SETTINGS.EDIT.USER',
          })}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleUpdate}>
        <Modal.Body>
          <Form.Group controlId="formName">
            <Form.Label>{intl.formatMessage({id: 'USER_MANAGER.FORM.NAME'})}</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(event) => setName(event.target.value)}
              required
            />
          </Form.Group>
          <Form.Group controlId="formFirstName">
            <Form.Label>{intl.formatMessage({id: 'USER_MANAGER.FORM.FIRST_NAME'})}</Form.Label>
            <Form.Control
              type="text"
              value={first_name}
              onChange={(event) => setFirstName(event.target.value)}
              required
            />
          </Form.Group>
          <Form.Group controlId="formEmail">
            <Form.Label>{intl.formatMessage({id: 'USER_MANAGER.FORM.EMAIL'})}</Form.Label>
            <Form.Control
              type="email"
              value={mail}
              onChange={(event) =>
                handleEmailChange(
                  event as React.ChangeEvent<HTMLInputElement>,
                  setMail,
                  clientId,
                  setEmailError
                )
              }
              required
            />
            {emailError && <div className="text-danger">{emailError}</div>}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="d-flex flex-column align-items-center">
          <div className="d-flex justify-content-center">
            <div className="me-4">
              <ButtonCancel onClick={() => setShowModal(false)} textId="CANCEL" />
            </div>
            <ButtonSubmit textId="SAVE" disabled={false} isLoading={false} />
          </div>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ModalEditUser;
